import { render, staticRenderFns } from "./PerformanceStatusIcon.vue?vue&type=template&id=2a3f3455&scoped=true&"
import script from "./PerformanceStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./PerformanceStatusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f3455",
  null
  
)

export default component.exports